import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@savvy-kit/components/dialog';

import { ArchivedClientsTable } from './archived-clients-table';

type ArchivedClientsDialogProps = {
  readonly onClose: () => void;
  readonly open: boolean;
  readonly dialogTriggerRender: React.ReactElement;
};

export function ArchivedClientsDialog({ onClose, open, dialogTriggerRender }: ArchivedClientsDialogProps) {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <DialogTrigger render={dialogTriggerRender} />
      <DialogContent className="flex max-h-[calc(100vh*0.5)] min-h-120 flex-col overflow-hidden">
        <DialogHeader className="shrink-0">
          <DialogTitle className="text-lg">Archived Clients</DialogTitle>
          <DialogDescription className="text-base">
            Households that are archived can be only be viewed. Restore households to enable editing
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-1 flex-col min-h-0 shrink">
          <ArchivedClientsTable />
        </div>
      </DialogContent>
    </Dialog>
  );
}
